<template>
    <div>
            <top-navbar></top-navbar>
    
    
            <div class=" mb-5 background_color" >
                <h6 class="manage-boder pt-2 font1  decoration"> <router-link class="decoration" to="/"> Home </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Distribution <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/dsales/index"> Manage Sales  </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Create Sales  </h6>
                <!-- <h6 class="custom-maintitle mb-2"><b>Create Customer </b></h6> -->
<div class="container-fluid">
  <div class="card bdr-rad2 mt-1 shadow p-2">
  <div  class="card-body custom_bdr_rds">


    <b-modal :id="infoModal2.id" 
     :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant"
      size="lg" hide-footer
     bottom>
    <template   #modal-title>
     
      <h5 >View Pending Sales</h5>

      
  
    </template>
    
   <div>
    <table class="table table-sm table-info table-striped font-size_def">
          <thead >
              <tr>
                  <th style="width:10%">Sales</th>
                  <th style="width:20%;">Dealer name</th>
                  <th style="width:20%;">Sales Person</th>
                  <th style="width:20%;">Qty</th>
                
               
                  
              </tr>                        
          </thead>
          <tbody id="">
            <tr v-for="conten in infoModal2.content" :key="conten.C_name">
              <td>{{ conten.qu_code  }}</td>
              <td>{{ conten.C_name }}</td>
              <td>{{ conten.name }}</td>
              <td>{{ conten.Qty }}</td>
            </tr>
            <tr>
              <th></th>
              <th>Total Available Qty</th>
              <th></th>
              <th>{{ qty }}</th>
            </tr>
               
          </tbody>
          </table>

   </div>

  

  
  </b-modal>


  <b-modal :id="infoModal1.id" 
     :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant"
      size="lg" hide-footer
     bottom>
    <template   #modal-title>
     
      <h5 >View Pending Sales</h5>

      
  
    </template>
    
   <div>
    <table class="table table-sm table-info table-striped font-size_def">
          <thead>
              <tr>
                  <th style="width:10%">Sales</th>
                  <th style="width:20%;">Dealer name</th>
                  <th style="width:20%;">Value</th>
                  <th style="width:20%;">Sales Person</th>
                
               
                  
              </tr>                        
          </thead>
          <tbody id="">
            <tr v-for="conten in infoModal1.content" :key="conten.C_name">
              <td>{{ conten.qu_code  }}</td>
              <td>{{ conten.C_name }}</td>
              <td>{{ conten.total }}</td>
              <td>{{ conten.name }}</td>
            </tr>
               
          </tbody>
          </table>

   </div>

  

  
  </b-modal>

   

                    <form @submit.prevent="SaveQuotation()" >


<div class="row">
    <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Customer</label>
            <v-select class="font-size_def" label="label"  @input="loadcontact"  v-model="squatation.idcustomer"  :options="mcustomers" :class="{'is-invalid': errors.idCustomerError}"></v-select>
            <div class="invalid-feedback">
              {{ errors.idCustomerError }}
            </div>
    </div>
  </div>

  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Customer Contact</label>
            <v-select class="font-size_def" label="label"   :options="contacts" v-model="squatation.customer_contact"
             :class="{'is-invalid': errors.customerContactError}"></v-select>
            <div class="invalid-feedback">
              {{ errors.customerContactError }}
            </div>
    </div>
  </div>
  
 
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Sales Date </label>
            <input type="date" v-model="squatation.received_date"   style="font-size: small;" class="form-control bdr-rad" required>
    </div>
  </div>
    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Payment Method </label>
            <v-select class="font-size_def" label="value" v-model="quotation.payment_method"  :options="paymentmethods" ></v-select>
    </div>
  </div>

</div>



<div class="row">
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Remarks</label>
           <textarea v-model="quotation.remarks" class="form-control bdr-rad" rows="2"></textarea>
    </div>
  </div>
</div>
















<div class="card custom_bdr_rds">
        <div class="card-body custom_bdr_rds">
    <h6 class="purchitem mb-2"><b>Add New Products</b></h6>
    <div class="table-responsive mb-1">
      <table style="font-size: small; " class="table  table-sm table-hover ">
        <thead  class="background_color2">
          <tr >
                <th ></th>
                <th  >   
                  <div class="form-group custom-form required">
                    <label class="custom-label2"> Product Code</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form ">
                    <label class="custom-label2"> Selling Price</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form ">
                    <label class="custom-label2">Available Qty</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form required">
                    <label class="custom-label2"> Qty</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form required">
                    <label class="custom-label2"> Discount %</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form required">
                    <label class="custom-label2"> Line Amount</label>
                  </div>
                </th>
              
                
              
                <th></th>  
            </tr>
          </thead>
          <tbody>
            <tr>
                <td>  <b-icon @click="remove" v-show="this.count>0" class="ms-3 me-3 mt-2"  width="8" type="button" icon="dash-lg" scale="2" variant=""></b-icon> </td>
              <td style="width: 20%;">
                <v-select  v-model="detail[0].idproduct" label="label"  :options="dproducts" @input="loadPrice(0)"></v-select>
              </td>
              <td><input v-model="detail[0].price"  style="font-size: small;" class="form-control text_right bdr-rad" disabled>
                <input type="hidden" v-model="detail[0].ave_cost"  style="font-size: small;" class="form-control" >
              </td>
              <td><input  v-model="detail[0].avlqty" style="font-size: small;" class="form-control text_right bdr-rad" disabled></td>
              <td><input  v-model="detail[0].qty" style="font-size: small;" class="form-control text_right bdr-rad" @input="calculateqty(0)" ></td>
              <td>
                <input  v-model="detail[0].line_discount" style="font-size: small;" class="form-control text_right bdr-rad" @input="calculatediscount(0)">
              </td>
              <td><input  v-model="detail[0].line_amount"  @input="calculatelinamt(0)" style="font-size: small;" class="form-control text_right bdr-rad" ></td>
             
           
              <td class="custom-icon">  <b-icon @click="add" class=" mt-2"  width="8" type="button" icon="plus-lg" scale="2" variant=""></b-icon></td>
              
            </tr>
            <tr v-for="key in count" :key="key" >
                <td>
                    <b-icon @click="remove" class="ms-3 me-3 mt-2"  width="8" type="button" icon="dash-lg" scale="2" variant=""></b-icon>
                </td>
              <td> <v-select v-model="detail[key].idproduct" label="label"  :options="dproducts" @input="loadPrice(key)"></v-select></td>
              <td><input  v-model="detail[key].price" style="font-size: small;" class="form-control text_right bdr-rad" disabled>
                <input type="hidden" v-model="detail[key].ave_cost"  style="font-size: small;" class="form-control " >
              </td>
              <td><input  v-model="detail[key].avlqty" style="font-size: small;" class="form-control text_right bdr-rad" disabled></td>
              <td><input  v-model="detail[key].qty" style="font-size: small;" class="form-control text_right bdr-rad" @input="calculateqty(key)" ></td>
              <td><input  v-model="detail[key].line_discount" style="font-size: small;" class="form-control text_right bdr-rad" @input="calculatediscount(key)" ></td>
              <td><input  v-model="detail[key].line_amount" @input="calculatelinamt(key)" style="font-size: small;" class="form-control text_right bdr-rad" ></td>
              <td class="custom-icon"> 
              
                 <b-icon @click="add" class=" mt-2"  width="8" type="button" icon="plus-lg" scale="2" variant=""></b-icon>
                 </td>
              
            </tr >
           
            
            <tr >
                <td> </td>
              <td></td>
              <td>Sub Total</td>
              <td></td>
              
              <td></td>
              <td></td>
              <td class="text_right" >{{ subtotal }}</td>
       
              <td></td>
              
            </tr>
            <tr >
                <td> </td>
              <td></td>
              <td>Special Discount</td>
              <td></td>
              
              <td></td>
              <td></td>
              <td><input v-model="quotation.special_discount"  style="font-size:small" class="form-control text_right bdr-rad" @input="spe_dis"></td>
              <td></td>
              
            </tr>
            <tr >
                <td> </td>
              <td></td>
              <td>Total</td>
              <td></td>
              
              <td></td>
              <td></td>
              <td class="text_right">{{ final_total }}</td>
              <td></td>
              
            </tr>

     
          
            
          </tbody>


        </table>
       
    </div>
    </div>
    </div>
    

    <div style="border-bottom: 0px; padding-top: 0px; " class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
        <button  type="submit" class="mr-1 btn btn-outline-primary  mb-1 font-size_def bdr-rad">Create</button>
    </div>
    </div>
    <br><br>


</form>




                </div>
                </div>
                <br><br>
              </div> 
            </div>
    
            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    
    </template>
    <script src="/js/vue-select/vue-select.js"> </script>
    <script type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/vue/1.0.13/vue.min.js"></script>
    <script>
      import vSelect from 'vue-select';
      import 'vue-select/dist/vue-select.css';
     import axios from 'axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'
     
    
    
      export default {

        mounted(){
    this.loadSalespeople();
    this.loadCustomer();
    this.loadDproducts();
      },
        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
            count: 0,
        total:0,
        selectedOption: null, // Store the selected option
        subtotal:"0.00",
        gpmrg_total:"0.00",
        gpMrgPre_total:"0.00",
        final_total:"0.00",
        qty:0,
        mcustomers:[],
        dproducts:[],
        contacts:[],
      salespeoples:[

      ],
      errors: {},
     
      squatation:{},
        customer:{},
        quotation:{
          'validity_period':{
            label: 'Select Validity Period', value: ''
          },
          'payment_method':{
            label: 'Cash', value: 'Cash'
          },
          'remarks':'',
          'special_discount':0.00,
        },
        sales:{},
        Brands:[],
        detail:[
      {},  
      ],
      infoModal1: {
          id: 'info-modal1',
          title: '',
          content: [],
        },
      infoModal2: {
          id: 'info-modal2',
          title: '',
          content: [],
        },

      paymentmethods: [
            { label: 'Cash', value: 'Cash' },
            { label: '30 Days Credit', value: '30 Days Credit' },
            { label: '45 Days Credit', value: '45 Days Credit' },
            { label: '60 Days Credit', value: '60 Days Credit' },
            { label: 'Consignment', value: 'Consignment' },
            // Add more options as needed
        ],
      validity_periodop: [
            { label: 'Select Validity Period', value: '' },
            { label: '7 Days', value: '7 Days' },
            { label: '14 Days', value: '14 Days' },
          
           
        ],
        variants: ['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'light', 'dark','mycoolor'],
        headerBgVariant: 'mycoolor',
        headerTextVariant: 'light',
           
          }
    
        },
        components :{
          'v-select': vSelect,
            ContentFooter,
            TopNavbar,
           
        },
    

        methods : {

          async pendingProductqu(id,avlqty) {

            console.log(id.value);
  
      
          
         
       try {
         const { data} = await  axios.get('/squatation/pendingproductqu?id='+id.value,{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          
            // this.loadSquatation();
           this.qty = avlqty-data.qty;
         
            this.infoModal2.content = data.results;
            this.$root.$emit('bv::show::modal', this.infoModal2.id);
        
         
       } catch (error) {
         console.log(error.response);
       }
     },





    async pendingQuotation() {
       console.log(this.squatation.idcustomer.value);
      
          
         
       try {
         const { data} = await  axios.get('/squatation/pendingquotation?id='+this.squatation.idcustomer.value,{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          
            // this.loadSquatation();
           
            this.infoModal1.content = data.results;
            this.$root.$emit('bv::show::modal', this.infoModal1.id);
        
         
       } catch (error) {
         console.log(error.response);
       }
     },

          async loadSalespeople() {
       
     
      try {
        const { data} = await  axios.get('/msalespeople/salespeopleload',{
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
         this.salespeoples = data.item_list;
         this.squatation.usd_rate = data.usd_rate;
         if (!this.sales || !this.sales.value) {
           this.sales = data.item_list && data.item_list.length ? data.item_list[0] : this.sales;
         }
        
      } catch (error) {
        console.log(error.response);
      }
    },

    
    async loadCustomer() {
      
       try {
         const { data} = await  axios.get('/mcustomer/customerload',{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          this.mcustomers = data.customers;
          this.contacts = data.contacts;
          this.mbrands = data.mbrands;
          if (!this.quotation.id_brand && this.mbrands && this.mbrands.length) {
            this.quotation.id_brand = this.mbrands[0];
          }
         
      } catch (error) {
        console.log(error.response);
      }
     },

     async loadcontact() {
       
     
       try {
         const { data} = await  axios.post('/mcustomer/loadcontact',{idcustomer:this.squatation.idcustomer},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          this.contacts = data.contacts;
          this.sales = data.salespeoples;
          
         
       } catch (error) {
         console.log(error.response);
       }
     },

     async loadDproducts() {
       try {
         const { data } = await axios.get('/dproduct/productload', {
           headers: {
             'Authorization': 'Bearer ' + this.access_token,
             'Content-type': 'application/json',
           }
         });
         console.log(data);
         this.dproducts = data.dproducts || [];
         this.loadSelectedProducts();
       } catch (error) {
         console.log(error.response);
       }
     },

     loadSelectedProducts() {
       const rawIds = this.$route.query.product_ids;
       const productIds = String(rawIds || '')
         .split(',')
         .map((id) => Number(id))
         .filter((id) => Number.isInteger(id) && id > 0);

       if (!productIds.length || !this.dproducts.length) {
         return;
       }

       const selectedProducts = productIds
         .map((id) => this.dproducts.find((product) => Number(product.value) === id))
         .filter(Boolean);

       if (!selectedProducts.length) {
         return;
       }

       this.detail = selectedProducts.map((product) => {
         const price = Number(product.price || 0);
         const availableQty = Number(product.avlqty || 0);
         const qty = availableQty > 0 ? 1 : 0;
         return {
           idproduct: product,
           price: price.toFixed(2),
           avlqty: availableQty,
           qty,
           line_discount: 0,
           line_amount: (price * qty).toFixed(2),
         };
       });
       this.count = Math.max(this.detail.length - 1, 0);
       this.recalculateSelectedTotals();
     },

     recalculateSelectedTotals() {
       const subtotal = this.detail.reduce((sum, item) => sum + Number(item.line_amount || 0), 0);
       this.subtotal = subtotal.toFixed(2);
       this.final_total = (subtotal - Number(this.quotation.special_discount || 0)).toFixed(2);
     },

     async loadPrice(id) {
       const selected = this.detail[id].idproduct || {};
       const price = parseFloat(selected.price || 0);
       this.$set(this.detail[id], 'price', price.toFixed(2));
       this.$set(this.detail[id], 'avlqty', Number.isFinite(Number(selected.avlqty)) ? Number(selected.avlqty) : 0);
       this.$set(this.detail[id], 'ave_cost', price.toFixed(2));
      },

     async calculateqty(id) {
      
     if(!this.detail[id].line_discount){
      this.detail[id].line_discount = 0;
     } 
    
     if(parseFloat(this.detail[id].avlqty) < parseFloat(this.detail[id].qty)){
      alert("You are not allowed enter more than remaining qty")
      this.$set(this.detail[id], 'qty', this.detail[id].avlqty);

      
     }
  const line_amount = (this.detail[id].price * this.detail[id].qty * (100 - this.detail[id].line_discount) / 100).toFixed(2);
  this.$set(this.detail[id], 'line_amount', line_amount);

  const gpMrg = (line_amount - this.detail[id].ave_cost*this.detail[id].qty).toFixed(2);
  this.$set(this.detail[id], 'gp_margin', gpMrg);

  const gpMrgPre = (gpMrg/line_amount*100).toFixed(2);
  this.$set(this.detail[id], 'gp_margin_precentage', gpMrgPre);

  let line_amount_tot = 0;
  let gpMrg_total1 = 0;
  let gpMrgPre_total = 0;
  for (let i = 0; i <= this.count; i++) {
 line_amount_tot = line_amount_tot + this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100;

 gpMrg_total1 = gpMrg_total1 + (( this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100) - this.detail[i].ave_cost*this.detail[i].qty);

  }

  this.subtotal = line_amount_tot.toFixed(2);
  this.gpmrg_total = gpMrg_total1.toFixed(2);

  this.gpMrgPre_total = (gpMrg_total1 / line_amount_tot * 100).toFixed(2);

  const total = line_amount_tot - this.quotation.special_discount;
  this.final_total = total.toFixed(2);
  
     },

     async calculatediscount(id) {
     if(!this.detail[id].qty){
      this.detail[id].qty = 0;
     } 
  const line_amount = this.detail[id].price * this.detail[id].qty * (100 - this.detail[id].line_discount) / 100;
  this.$set(this.detail[id], 'line_amount', line_amount);

  const gpMrg = (line_amount - this.detail[id].ave_cost*this.detail[id].qty).toFixed(2);
  this.$set(this.detail[id], 'gp_margin', gpMrg);

  const gpMrgPre = (gpMrg/line_amount*100).toFixed(2);
  this.$set(this.detail[id], 'gp_margin_precentage', gpMrgPre);

  let line_amount_tot = 0;
  let gpMrg_total = 0;
  let gpMrgPre_total = 0;
  for (let i = 0; i <= this.count; i++) {
 line_amount_tot = line_amount_tot + this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100;

 gpMrg_total = gpMrg_total + (( this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100) - this.detail[i].ave_cost*this.detail[i].qty);

 
 
  }
  this.subtotal = line_amount_tot.toFixed(2);
  this.gpmrg_total = gpMrg_total.toFixed(2);
  this.gpMrgPre_total = (gpMrg_total1 / line_amount_tot * 100).toFixed(2);

  const total = line_amount_tot - this.quotation.special_discount;
  this.final_total = total.toFixed(2);

     },


     async calculatelinamt(id) {

      const discount = (100 - ((this.detail[id].line_amount*100)/(this.detail[id].price*this.detail[id].qty))).toFixed(2);
      this.$set(this.detail[id], 'line_discount', discount);

      const gpMrg = (this.detail[id].line_amount - this.detail[id].ave_cost*this.detail[id].qty).toFixed(2);
      this.$set(this.detail[id], 'gp_margin', gpMrg);

      const gpMrgPre = (gpMrg/this.detail[id].line_amount*100).toFixed(2);
      this.$set(this.detail[id], 'gp_margin_precentage', gpMrgPre);


      let line_amount_tot = 0;
      let gpMrg_total = 0;
      let gpMrgPre_total = 0;
      for (let i = 0; i <= this.count; i++) {
      line_amount_tot = line_amount_tot + this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100;

      gpMrg_total = gpMrg_total + (( this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100) - this.detail[i].ave_cost*this.detail[i].qty);

    
    
      }
      this.subtotal = line_amount_tot.toFixed(2);
      this.gpmrg_total = gpMrg_total.toFixed(2);
      this.gpMrgPre_total = (gpMrg_total / line_amount_tot * 100).toFixed(2);


      const total = line_amount_tot - this.quotation.special_discount;
      this.final_total = total.toFixed(2);



     },

     async calculategpmarg(id) {
      
       const dis = (100-((parseFloat(this.detail[id].gp_margin / this.detail[id].qty) + parseFloat(this.detail[id].ave_cost))*100/this.detail[id].price)).toFixed(2);
        this.$set(this.detail[id], 'line_discount', dis);


        const line_amount = (this.detail[id].price * this.detail[id].qty * (100 - dis) / 100).toFixed(2);
        this.$set(this.detail[id], 'line_amount', line_amount);

        const gpMrgPre = (this.detail[id].gp_margin/line_amount*100).toFixed(2);
        this.$set(this.detail[id], 'gp_margin_precentage', gpMrgPre);


      let line_amount_tot = 0;
      let gpMrg_total = 0;
      let gpMrgPre_total = 0;
      for (let i = 0; i <= this.count; i++) {
      line_amount_tot = line_amount_tot + this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100;

      gpMrg_total = gpMrg_total + (( this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100) - this.detail[i].ave_cost*this.detail[i].qty);

    
    
      }
      this.subtotal = line_amount_tot.toFixed(2);
      this.gpmrg_total = gpMrg_total.toFixed(2);
      this.gpMrgPre_total = (gpMrg_total / line_amount_tot * 100).toFixed(2);


      const total = line_amount_tot - this.quotation.special_discount;
      this.final_total = total.toFixed(2);


     },

     async calculategppre(id) {

      const dis =  (100 -(this.detail[id].ave_cost*10000/((this.detail[id].price)*(100-this.detail[id].gp_margin_precentage)))).toFixed(2);
      this.$set(this.detail[id], 'line_discount', dis);

      const line_amount = (this.detail[id].price * this.detail[id].qty * (100 - dis) / 100).toFixed(2);
        this.$set(this.detail[id], 'line_amount', line_amount);

        const gpMrg = (this.detail[id].line_amount - this.detail[id].ave_cost*this.detail[id].qty).toFixed(2);
      this.$set(this.detail[id], 'gp_margin', gpMrg);

      let line_amount_tot = 0;
      let gpMrg_total = 0;
      let gpMrgPre_total = 0;
      for (let i = 0; i <= this.count; i++) {
      line_amount_tot = line_amount_tot + this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100;

      gpMrg_total = gpMrg_total + (( this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100) - this.detail[i].ave_cost*this.detail[i].qty);

    
    
      }
      this.subtotal = line_amount_tot.toFixed(2);
      this.gpmrg_total = gpMrg_total.toFixed(2);
      this.gpMrgPre_total = (gpMrg_total / line_amount_tot * 100).toFixed(2);


      const total = line_amount_tot - this.quotation.special_discount;
      this.final_total = total.toFixed(2);



     },



     async spe_dis() {
        const total = this.subtotal - this.quotation.special_discount;
        this.final_total = total.toFixed(2);
     },

     validate(){
      this.errors = {};
      if(this.squatation.idcustomer == null){
        this.$set(this.errors, 'idCustomerError', "Customer field is required");
      }
      if(this.squatation.customer_contact == null){
        this.$set(this.errors, 'customerContactError', "Customer Contact field is required");
      }
     },

    async SaveQuotation() {
     
      if (!this.sales && this.salespeoples && this.salespeoples.length) {
        this.sales = this.salespeoples[0];
      }
      if (!this.quotation.id_brand && this.mbrands && this.mbrands.length) {
        this.quotation.id_brand = this.mbrands[0];
      }
      if (!this.quotation.validity_period || !this.quotation.validity_period.value) {
        this.quotation.validity_period = { label: '14 Days', value: '14 Days' };
      }
      if (!this.squatation.usd_rate) {
        this.squatation.usd_rate = 300;
      }

      this.validate();

      if(Object.keys(this.errors).length === 0){
        try {
          const sale = {
            customer_id: this.optionValue(this.squatation.idcustomer),
            customer_contact: this.optionValue(this.squatation.customer_contact),
            sales_person_id: this.optionValue(this.sales),
            sales_person_name: this.sales && this.sales.label ? this.sales.label : '',
            sales_date: this.squatation.received_date,
            payment_method: this.optionValue(this.quotation.payment_method),
            remarks: this.quotation.remarks || '',
            special_discount: Number(this.quotation.special_discount || 0),
          };
          const details = this.detail
            .map((item) => ({
              id_product: this.optionValue(item.idproduct),
              price: Number(item.price || 0),
              qty: Number(item.qty || 0),
              line_discount: Number(item.line_discount || 0),
              line_amount: Number(item.line_amount || 0),
            }))
            .filter((item) => item.id_product && item.qty > 0);

         const { data} = await  axios.post('/dsales/create',{sales:sale,details},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
        if(data && data.status==200){
          this.$router.push('/dsales/index');
        }
          
           
         
       } catch (error) {
         console.log(error.response);
       }
      }
       
      
 
      
     },

     optionValue(value) {
       if (value && typeof value === 'object') {
         return value.value !== undefined ? value.value : (value.id !== undefined ? value.id : '');
       }
       return value || '';
     },
       

        add: function(){
            this.count++;
            this.detail.push({
             
            },)
           
        },

  remove: function () {
            this.count--;
            this.detail.splice({
              
            },1)
            
        },

    },
    
    }
    
    </script>

    <style scoped>
    .button-link {
  display: inline-block;
  padding: 5px 10px;
  font-size: small;
  text-decoration: none;
  color: #3899ea;
 
 
  
  cursor: pointer;
}

.button-link:hover {
  color: black;
  text-decoration: underline;
}
      /* @import "vue-select/dist/vue-select.css"; */
/* .vs__dropdown-option--disabled {
    display: block;
} */
    </style>
    
